import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";

const useStyles = CreateResponsiveStyle(
  {
    contentWrapper: {
      display: "flex",
      marginLeft: 50,
      paddingLeft: 40,
      paddingTop: 8.3,
      marginRight: 63,
    },
    mobileDescViewStyle: {
      display: "none",
    },
    footer: {
      width: "100%",
      minHeight: 44,
      alignItems: "flex-end",
    },
    procedBtn: {
      width: 220,
      height: 40,
      alignSelf: "flex-end",
      marginTop: 10,
    },
    custInfoWrapper: {
      flex: 1,
      gap: 15,
      marginTop: 32.6,
    },
    infoWrapper: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 30,
      position: "relative",
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 10,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {
      infoWrapper: {
        gap: 20,
      },
      contentWrapper: {
        marginLeft: 20,
        marginRight: 20,
        paddingLeft: 10,
      },
      custInfoWrapper: {
        gap: 1,
      },
    },
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {
      contentWrapper: {
        flexDirection: "column",
        alignSelf: "center",
        alignItems: "center",

        marginLeft: 0,
        paddingLeft: 0,
        paddingTop: 8.3,
        marginRight: 0,
      },
      infoWrapper: {
        flexDirection: "column",
        gap: 10,
      },
      custInfoWrapper: {
        marginTop: 30,
      },
      footer: {
        alignSelf: "center",
        marginTop: 30,
      },
      mobileDescViewStyle: {
        alignSelf: "center",
        display: "flex",
      },
    },
  }
);

export default useStyles